module.exports = __webpack_public_path__ + "img/27.f10baf30.png";